import { render } from "./expertAccountPage.vue?vue&type=template&id=716b2252&scoped=true&ts=true"
import script from "./expertAccountPage.vue?vue&type=script&lang=ts"
export * from "./expertAccountPage.vue?vue&type=script&lang=ts"

import "./expertAccountPage.vue?vue&type=style&index=0&id=716b2252&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716b2252"]])

export default __exports__